import { money } from "@/lib/format";

const median = (xs) => {
  if (!xs.length) return null;
  const s = [...xs].sort((a, b) => a - b);
  const m = Math.floor(s.length / 2);
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
};
const avg = (xs) => (xs.length ? xs.reduce((a, b) => a + b, 0) / xs.length : null);

/** Market snapshot computed from the homes currently shown (live REIN data once the feed is connected). */
export const MarketSnapshot = ({ listings = [], title = "Market snapshot", sample = false, compact = false, testId = "market-snapshot" }) => {
  const priced = listings.filter((l) => l.price);
  const ppsf = priced.filter((l) => l.sqft).map((l) => l.price / l.sqft);
  const dom = listings.map((l) => l.days_on_market).filter((d) => d != null);
  const stats = [
    { id: "count", label: "Homes for sale", value: listings.length.toLocaleString() },
    { id: "median", label: "Median list price", value: priced.length ? money(median(priced.map((l) => l.price))) : "—" },
    { id: "ppsf", label: "Avg. price / sq ft", value: ppsf.length ? money(avg(ppsf)) : "—" },
    { id: "dom", label: "Avg. days on market", value: dom.length ? Math.round(avg(dom)) : "—" },
  ];
  return (
    <div className={compact ? "" : "rounded-md border border-neutral-200 bg-white p-5 sm:p-6"} data-testid={testId}>
      {!compact && (
        <div className="mb-4 flex flex-wrap items-baseline justify-between gap-2">
          <p className="eyebrow">{title}</p>
          {sample && <p className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">From sample listings</p>}
        </div>
      )}
      <dl className="grid grid-cols-2 gap-px overflow-hidden rounded-md bg-neutral-200 sm:grid-cols-4">
        {stats.map((s) => (
          <div key={s.id} className="bg-white p-3 sm:p-4">
            <dt className="text-[12px] text-neutral-500">{s.label}</dt>
            <dd className={`mt-1 font-medium text-ink ${compact ? "text-lg" : "text-xl sm:text-2xl"}`} data-testid={`${testId}-${s.id}`}>{s.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
